import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { listOfLinksMicrositeAPIService } from '~/api/microsites/links';
import DEFAULT_LIST_OF_LINKS_0 from '~/assets/icons/DEFAULT_LIST_OF_LINKS_0.png';
import DEFAULT_LIST_OF_LINKS_1 from '~/assets/icons/DEFAULT_LIST_OF_LINKS_1.png';
import DEFAULT_LIST_OF_LINKS_2 from '~/assets/icons/DEFAULT_LIST_OF_LINKS_2.png';
import DEFAULT_LIST_OF_LINKS_3 from '~/assets/icons/DEFAULT_LIST_OF_LINKS_3.png';
import DEFAULT_LIST_OF_LINKS_COVER_IMAGE from '~/assets/icons/DEFAULT_LIST_OF_LINKS_COVER_IMAGE.png';
import DEFAULT_LIST_OF_LINKS_LOGO from '~/assets/icons/DEFAULT_LIST_OF_LINKS_LOGO.png';
import { LIST_OF_LINKS_MOCK_TEXT } from '~/constants/mock-text';
import { SOCIAL_ICON_ITEMS } from '~/constants/socials';

export const updateListOfLinksSiteThunk = createAsyncThunk(
  'listOfLinksSlice/updateModelThunk',
  async (body, { rejectWithValue }) => {
    try {
      const response = await listOfLinksMicrositeAPIService.updateListOfLinksSite(body);

      if (body.dispatchHandler) {
        body.dispatchHandler();
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateLinksThunk = createAsyncThunk(
  'listOfLinksSlice/updateLinksThunk',
  async ({ body, id, dispatchHandler }, { rejectWithValue }) => {
    try {
      const response = await listOfLinksMicrositeAPIService.updateLink(id, body);

      if (dispatchHandler) {
        dispatchHandler();
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

//socials
export const updateListOfLinksSocialThunk = createAsyncThunk(
  'listOfLinksSlice/updateListOfLinksSocialThunk',
  async ({ body, id, type, dispatchHandler }, { rejectWithValue }) => {
    try {
      if (type === 'add') {
        await listOfLinksMicrositeAPIService.createListOfLinksSocial(body);
      } else if (type === 'update') {
        await listOfLinksMicrositeAPIService.updateListOfLinksSocial(body.data, body.id);
      } else if (type === 'delete') {
        await listOfLinksMicrositeAPIService.deleteListOfLinksSocial(body);
      }
      const response = await listOfLinksMicrositeAPIService.getListOfLinksSite(id);
      if (dispatchHandler) {
        dispatchHandler();
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const listOfLinksSlice = createSlice({
  name: 'listOfLinksSlice',
  initialState: {
    title: '',
    selectedTemplate: 0,
    // bacgkroundColor: ['#5356FF', '#ffffff', '#000000'],
    bacgkroundColor: ['#FFFCE8', '#ffffff', '#EDDC6A'],
    fonts: {
      title: '',
      text: '',
    },
    fontsSize: {
      titleSize: '18px',
      descriptionSize: '10px',
      socialMediaSize: '32px',
    },
    basicInformation: {
      logoImage: {
        url: DEFAULT_LIST_OF_LINKS_LOGO,
        scale: 100,
        borderRadius: 50,
        rotate: 0,
      },
      coverImage: {
        url: DEFAULT_LIST_OF_LINKS_COVER_IMAGE,
      },
      h1: LIST_OF_LINKS_MOCK_TEXT.H1_FULL_TEXT,
      h2: LIST_OF_LINKS_MOCK_TEXT.H2_FULL_TEXT,
    },
    content: {
      linkList: [
        {
          previewLink: DEFAULT_LIST_OF_LINKS_0,
          url: 'https://example.com',
          linkText: 'Lorem ipsum',
          id: 'UNIQUE_ID_0',
        },
        {
          previewLink: DEFAULT_LIST_OF_LINKS_1,
          url: 'https://example.com',
          linkText: 'Lorem ipsum',
          id: 'UNIQUE_ID_1',
        },
        {
          previewLink: DEFAULT_LIST_OF_LINKS_2,
          url: 'https://example.com',
          linkText: 'Lorem ipsum',
          id: 'UNIQUE_ID_2',
        },
        {
          previewLink: DEFAULT_LIST_OF_LINKS_3,
          url: 'https://example.com',
          linkText: 'Lorem ipsum',
          id: 'UNIQUE_ID_3',
        },
      ],
      imagesType: 'VERTICAL',
      images: [],
      socialLinks: [
        { label: 'Instagram', value: 'https://www.instagram.com', title: '', network: SOCIAL_ICON_ITEMS[1].network },
        { label: 'Facebook', value: 'https://www.facebook.com', title: '', network: SOCIAL_ICON_ITEMS[3].network },
        { label: 'X', value: 'https://x.com', title: '', network: SOCIAL_ICON_ITEMS[31].network },
      ],
    },
    stats: {
      isAutogeneratedUrl: true,
      isLimitsEnabled: false,
      url: '',
      scan: '',
    },
    loading: false,
    error: null,
    micrositeData: null,
    micrositeStyles: {
      container: {},
    },
    isDeleteSocialLoading: false,
  },
  reducers: {
    setTitle(state, action) {
      state.title = action.payload;
    },
    setSelectedTemplate(state, action) {
      state.selectedTemplate = action.payload;
    },
    setBackgroundColor(state, action) {
      state.bacgkroundColor = action.payload;
    },
    setFonts(state, action) {
      state.fonts[action.payload.field] = action.payload.value;
    },
    setFontsSize(state, action) {
      state.fontsSize[action.payload.field] = action.payload.value;
    },
    setSocialLinks(state, action) {
      state.content.socialLinks = action.payload;
    },
    setBasicInformation(state, action) {
      state.basicInformation[action.payload.field] = action.payload.value;
    },
    setStats(state, action) {
      state.stats[action.payload.field] = action.payload.value;
    },
    setStatsData(state, action) {
      state.stats = action.payload;
    },
    setNewCoverImage(state, action) {
      state.basicInformation.images[action.payload.index].previewLink = action.payload.url;
    },
    setContentLinkList(state, action) {
      state.content.linkList = action.payload;
    },
    setContentLinkListValues(state, action) {
      state.content.linkList[action.payload.index][action.payload.field] = action.payload.value;
    },
    setImages(state, action) {
      state.content.images = action.payload;
    },
    setImagesType(state, action) {
      state.content.imagesType = action.payload;
    },
    setMicrositeData(state, action) {
      state.micrositeData = action.payload;
    },
    setMicrositeStyles(state, action) {
      state.micrositeStyles = action.payload;
    },
    resetState: () => listOfLinksSlice.getInitialState(),
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateListOfLinksSiteThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateListOfLinksSiteThunk.fulfilled, (state, action) => {
        state.loading = true;
        state.data = action.payload;
      })
      .addCase(updateListOfLinksSiteThunk.rejected, (state, action) => {
        state.loading = true;
        state.error = action.payload;
      })
      .addCase(updateLinksThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateLinksThunk.fulfilled, (state, action) => {
        state.loading = true;
        state.data = action.payload;
      })
      .addCase(updateLinksThunk.rejected, (state, action) => {
        state.loading = true;
        state.error = action.payload;
      })
      //social
      .addCase(updateListOfLinksSocialThunk.pending, (state, action) => {
        if (action.meta.arg.type === 'delete') {
          state.isDeleteSocialLoading = true;
        }
        state.loading = true;
        state.error = null;
      })
      .addCase(updateListOfLinksSocialThunk.fulfilled, (state, action) => {
        if (action.meta.arg.type === 'delete') {
          state.isDeleteSocialLoading = false;
        }
        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updateListOfLinksSocialThunk.rejected, (state, action) => {
        if (action.meta.arg.type === 'delete') {
          state.isDeleteSocialLoading = false;
        }

        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default listOfLinksSlice.reducer;
